import * as types from '@/store/mutation-types';
import { guid } from '@/mixins/guid';
import payload from '@/payloads/users';
import { DEFAULT_PROFILE_PIC } from '@/constants';
import _ from 'lodash';

const state = {
  currentUser: {},
  users: [],
  subUsers: [],
  subUsersFetched: false,
};

const getters = {
  currentUser() {
    return state.currentUser;
  },
  users(state) {
    return state.users;
  },
  subUsers(state) {
    return state.subUsers;
  },
  subUsersFetched(state) {
    return state.subUsersFetched;
  },
};

const mutations = {
  [types.SET_CURRENT_USER](state, p) {
    // currentUser uses properties from both dynamo and cognito
    if (p) {
      _.forOwn(p.values, (value, key) => {
        let k = key;
        let v = value;
        if (key === 'websites') {
          v = value.map(s => s._id);
        }
        if (key === 'name') {
          k = 'fullName';
        }
        if (key === 'picture') {
          k = 'pic';
          v = value || DEFAULT_PROFILE_PIC;
        }
        if (key === 'website') {
          k = 'org';
        }
        if (!state.currentUser[k]) {
          p.vm.$set(state.currentUser, k, v);
        } else {
          state.currentUser[k] = v;
        }
      });
    } else {
      state.currentUser = {};
    }
    this._vm.$log.debug('SET_CURRENT_USER: ', state.currentUser);
  },
  [types.GET_USERS](state) {
    state.users = payload.users;
  },
  [types.INVITE_USER](state, p) {
    state.users.push(p.newUser);
  },
  [types.SET_USER_ATTRIBUTE](state, p) {
    _.extend(state.currentUser, p);
  },
  [types.SET_SUBUSERS_FETCHED](state, p) {
    state.subUsersFetched = p;
  },
  [types.SET_SUBUSERS](state, p) {
    state.subUsers = p;
  },
};

const actions = {
  setCurrentUser: ({ commit }, payload) =>
    new Promise((resolve) => {
      commit(types.SET_CURRENT_USER, payload);
      resolve();
    }),
  getUsers: ({ commit }, payload) => {
    commit(types.GET_USERS, payload);
  },
  setUserAttribute: ({ commit }, payload) => {
    commit(types.SET_USER_ATTRIBUTE, payload);
  },
  setSubUsers: ({ commit }, payload) => {
    commit(types.SET_SUBUSERS, payload);
  },
  setSubUsersFetched: ({ commit }, payload) => {
    commit(types.SET_SUBUSERS_FETCHED, payload);
  },
  inviteUser: ({ dispatch }, payload) => {
    dispatch('addNotification', {
      id: guid.methods.guid(),
      type: 'success',
      message: `Invite sent to ${payload.inviteEmail}!`,
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/admin/sub-users/vuex.js